var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoints2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 465,
    height: 500,
    viewBox: "0 0 465 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_597_3248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.55 49.42C224.063 49.42 225.29 48.1933 225.29 46.68C225.29 45.1667 224.063 43.94 222.55 43.94C221.037 43.94 219.81 45.1667 219.81 46.68C219.81 48.1933 221.037 49.42 222.55 49.42Z",
    stroke: "#144AF4",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.95 30.91C44.4633 30.91 45.69 29.6833 45.69 28.17C45.69 26.6567 44.4633 25.43 42.95 25.43C41.4368 25.43 40.21 26.6567 40.21 28.17C40.21 29.6833 41.4368 30.91 42.95 30.91Z",
    stroke: "#144AF4",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.77 131.14H270.81",
    stroke: "#144AF4",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.67 303.71H40.71",
    stroke: "#144AF4",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.57 370.1H414.61",
    stroke: "#144AF4",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96 189.33H0",
    stroke: "#144AF4",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.38 189.33H13.4",
    stroke: "#144AF4",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_597_3248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 522.95,
    height: 687.52,
    fill: "white",
    transform: "translate(0 -61)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints2);
export default __webpack_public_path__ + "static/media/points 2.a0b93380399e598697184bdc79919b87.svg";
export { ForwardRef as ReactComponent };